export default __webpack_public_path__ + "static/media/Anonymous.f59e088a.svg";